import { NAV_LINKS } from "../data";

export const Footer = () => {
  const year = new Date().getFullYear();
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="site-footer" className="mt-16 lg:mt-24 px-6 lg:px-12 pb-10">
      <div className="overflow-hidden border-t border-foreground/10 pt-10">
        <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.8] text-[18vw] lg:text-[14vw] select-none">
          Sixes<span className="text-primary">&</span>Sevens
        </h2>
      </div>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-foreground/10 pt-10 text-sm text-foreground/50">
        <div>
          <p className="uppercase tracking-[0.2em] text-foreground/40 mb-3">Menu</p>
          <div className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="link-underline text-left w-fit text-foreground/70 hover:text-foreground transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="uppercase tracking-[0.2em] text-foreground/40 mb-3">Social</p>
          <div className="flex flex-col gap-2">
            {["Instagram", "Vimeo", "LinkedIn", "Behance"].map((s) => (
              <a key={s} href="#top" className="link-underline w-fit text-foreground/70 hover:text-foreground transition-colors">
                {s}
              </a>
            ))}
          </div>
        </div>
        <div className="md:text-right">
          <p className="uppercase tracking-[0.2em] text-foreground/40 mb-3">Studio</p>
          <p className="text-foreground/70">sixesandsevens01@gmail.com</p>
          <p className="mt-1">Mumbai · Worldwide</p>
        </div>
      </div>
      <div className="mt-10 flex flex-col sm:flex-row justify-between gap-2 text-xs uppercase tracking-[0.2em] text-foreground/40">
        <span>© {year} Sixes & Sevens</span>
        <span>Brand · Production · Everything between</span>
      </div>
    </footer>
  );
};
